module.exports = __webpack_public_path__ + "static/img/rank_225.0756c50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_225.png
// module id = 1KJy
// module chunks = 0